export const BNK_STMT_updateRequiredStatementsReducer = {
  BNK_STMT_updateRequiredStatements: (state, action) => {
    state.requiredStatements = action.payload;
  },
};
